/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskExperianBusinessEntry } from './ExecRiskExperianBusinessEntry';
import {
    ExecRiskExperianBusinessEntryFromJSON,
    ExecRiskExperianBusinessEntryFromJSONTyped,
    ExecRiskExperianBusinessEntryToJSON,
} from './ExecRiskExperianBusinessEntry';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedExperianResponse
 */
export interface ExecRiskPaginatedExperianResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedExperianResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskExperianBusinessEntry>}
     * @memberof ExecRiskPaginatedExperianResponse
     */
    results: Array<ExecRiskExperianBusinessEntry>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedExperianResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedExperianResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedExperianResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedExperianResponse interface.
 */
export function instanceOfExecRiskPaginatedExperianResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedExperianResponseFromJSON(json: any): ExecRiskPaginatedExperianResponse {
    return ExecRiskPaginatedExperianResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedExperianResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedExperianResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskExperianBusinessEntryFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedExperianResponseToJSON(value?: ExecRiskPaginatedExperianResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskExperianBusinessEntryToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

